<ng-container *transloco="let t;">
  <form (submit)="onSubmit()" novalidate *ngIf="ac !== null">

    <app-loader [loading]="loading"></app-loader>

    <ng-container *ngIf="loading !== true">

      <div class="p-grid">
          <div class="p-col-6">
              <h2>{{ t('common.labels.persons') }}</h2>
          </div>
          <div withRight="admin.ac.edit" class="p-col-6 p-text-right" *ngIf="ac.not_yet_started && inEdit !== true">
            <button pButton (click)="onEdit()" type="button" label="{{ t('common.labels.edit') }}" icon="pi pi-pencil" class="p-button-sm p-mb-2 autofocus"></button>
            <button *ngIf="inEdit !== true && canShowInvitation() === true && !invitationSended()" pButton (click)="onSendInvitations()" type="button" icon="pi pi-envelope" label="{{ t('common.labels.send_invitations') }}" class="p-button-sm p-button-success p-mb-2 p-ml-2" [disabled]="ac.start_time === null"></button>
          </div>
          <div class="p-col-6 p-text-right" *ngIf="inEdit === true">
            <app-form-buttons [submitting]="submitting" (cancelled)="onCancel()"></app-form-buttons>
          </div>
      </div>


      <div class="p-grid">
        <div class="p-col-12 p-md-6">
            <h3>{{ t('common.labels.moderator') }}</h3>
            <app-form-control [cid]="'moderator'" [control]="form.get('moderator')" [type]="'select'" [options]="moderators" optionLabel="fullname_reverse" [label]="''" [edit]="inEdit" [basevalue]="ac.moderator_name"></app-form-control>
        </div>
      </div>

      <app-ac-persons-candidates
        [ac]="ac"
        [inEdit]="inEdit"
        [submitting]="submitting"
        (sendInvitation)="onSendInvitations($event)"
        #candidates
      >
      </app-ac-persons-candidates>

      <app-ac-persons-observers
        [form]="form"
        [observers]="observers"
        [ac]="ac"
        [inEdit]="inEdit"
        [submitting]="submitting"
        (sendInvitation)="onSendInvitations(null, $event)"
        #participants
      >
      </app-ac-persons-observers>

    </ng-container>

  </form>
</ng-container>
